import React from "react"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import Hidden from "@material-ui/core/Hidden"
import { useStaticQuery, graphql } from "gatsby"
import SocialButtons from "./social-buttons"

const Footer = props => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)

  const siteUrl = data.site.siteMetadata.siteUrl || ""

  return (
    <React.Fragment>
      <Hidden xsDown>
        <Box
          className={"footer"}
          style={{
            height: props.fromLanding ? "15rem" : "8rem",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            display: "flex",
            flexDirection: "column",
            boxShadow: "0 0 10px 0 rgba(0,0,0,.05)",
          }}
        >
          <SocialButtons youtube={true} />

          {props.fromLanding && (
            <Typography
              variant={"body1"}
              style={{ padding: 5 }}
              className={"footer-text"}
            >
              Copyright © <a href={siteUrl}>{"codewithsamiya.com"}</a>{" "}
              {new Date().getFullYear()}
            </Typography>
          )}

          {!props.fromLanding && (
            <React.Fragment>
              <Typography
                variant={"body1"}
                style={{ padding: 5 }}
                className={"text-secondary"}
              >
                Copyright © <a href={siteUrl}>{"codewithsamiya.com"}</a>{" "}
                {new Date().getFullYear()}
              </Typography>
              <Typography variant={"body1"} className={"text-secondary"}>
                <a
                  href={siteUrl + "/privacy-policy"}
                  className={"text-secondary"}
                >
                  {"Privacy Policy"}
                </a>
              </Typography>
            </React.Fragment>
          )}
        </Box>
      </Hidden>

      <Hidden smUp>
        <Box
          style={{
            backgroundColor: "#5f5f5f",
            height: "4rem",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant={"caption"}>
            Copyright ©{" "}
            <a href={siteUrl} style={{ color: "white" }}>
              {"codewithsamiya.com"}
            </a>{" "}
            {new Date().getFullYear()}
          </Typography>
          {!props.fromLanding && (
            <Typography variant={"caption"}>
              <a href={siteUrl + "/privacy-policy"} style={{ color: "white" }}>
                {"Privacy Policy"}
              </a>
            </Typography>
          )}
        </Box>
      </Hidden>
    </React.Fragment>
  )
}

export default Footer
